import { render } from "./HomeChallenges.vue?vue&type=template&id=771b357d&scoped=true"
import script from "./HomeChallenges.vue?vue&type=script&lang=js"
export * from "./HomeChallenges.vue?vue&type=script&lang=js"

import "./HomeChallenges.vue?vue&type=style&index=0&id=771b357d&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-771b357d"

export default script